import { $axios } from "../config/axios";

export default {
  saveResourceDetails(payload) {
    return $axios.post("/ponds/medicines-and-minerals", payload);
  },
  fetchResourcesByPondId(pondId, params) {
    return $axios.get(`/ponds/${pondId}/medicines-and-minerals`, { params });
  },
  fetchAllResources() {
    return $axios.get("/ponds/medicines-and-minerals");
  },
  addMedicinesToPonds(params) {
    return $axios.post("/ponds/medicines-and-minerals", params);
  },
  deleteMedicinesAndMineralsInPonds(record_id) {
    return $axios.delete(`/ponds/medicines-and-minerals/${record_id}`);
  },
  fetchLabTests(pond_id, params) {
    return $axios.get(`/ponds/${pond_id}/lab-tests`, { params });
  },
  addLabTestsToPond(payload) {
    console.log(payload);
    return $axios.post("/lab-tests", payload);
  },
  deleteLabTestFromPond(record_id) {
    return $axios.delete(`/lab-tests/${record_id}`);
  },
  fetchLabTestsByLocation(params) {
    console.log(params);
    return $axios.get(`/lab-tests`, { params });
  },
  addResourceToPond(params) {
    return $axios.post("/ponds/feed-type", params);
  },
  deleteResourceFromPond(pond_id) {
    return $axios.post(`/ponds/${pond_id}/feed-type`);
  },
};
